import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import UserGroupOptions from 'views/user-groups/UserGroupOptions';
// import ClassView from 'views/classes/ClassView';
import ProductCategories from 'views/products/ProductCategories';

import Assignments from 'views/pages/assignments/Assignments';
import ContainerList from 'views/pages/containers/ContainerList';
import AddContainer from 'views/pages/containers/AddContainer';
import RulesPage from 'views/pages/Rules/RulesPage';

// Lazy loaded pages
const Home = Loadable(lazy(() => import('views/home')));
const SingleQuestion = Loadable(lazy(() => import('views/questions/QuestionList')));
const AddQestion = Loadable(lazy(() => import('views/single-question/AddQuestion')));
const Collection = Loadable(lazy(() => import('views/collection/Collection')));
const CollectionList = Loadable(lazy(() => import('views/questions/CollectionList')));
const Users = Loadable(lazy(() => import('views/users/Users')));
const UserGroups = Loadable(lazy(() => import('views/user-groups/UserGroups')));
const LogbookList = Loadable(lazy(() => import('views/logbook/Logbook')));
const LogBookDetails = Loadable(lazy(() => import('views/logbook/MoreDetails')));
const SystemReports = Loadable(lazy(() => import('views/system-reports/SystemReports')));
const TagList = Loadable(lazy(() => import('views/tag-management/TagsList')));
const ProductList = Loadable(lazy(() => import('views/products/ProductList')));
const AddProduct = Loadable(lazy(() => import('views/products/AddProduct')));
const CoursesList = Loadable(lazy(() => import('views/courses/CoursesList')));
const AddCourse = Loadable(lazy(() => import('views/courses/AddCourse')));
const AtomicUnitList = Loadable(lazy(() => import('views/atomic-unit/AtomicUnitList')));
const Connection = Loadable(lazy(() => import('views/essay/Connection')));
const AddAtomicUnit = Loadable(lazy(() => import('views/atomic-unit/AddAtomicUnit')));
const AddAssignment = Loadable(lazy(() => import('views/pages/assignments/AddAssinment')));
const SpecsList = Loadable(lazy(() => import('views/specs/SpecsList')));
const AddSpecs = Loadable(lazy(() => import('views/specs/AddSpecs')));
const ClassesList = Loadable(lazy(() => import('views/classes/ClassesList')));
const ClassView = Loadable(lazy(() => import('views/classes/ClassView')));
const ConnectionToProduct = Loadable(lazy(() => import('views/essay/ConnectionToProduct')));
const NoteManageMent = Loadable(lazy(() => import('views/essay/NoteManageMent')));
const Essay = Loadable(lazy(() => import('views/essay/EssayList')));
const EssayView = Loadable(lazy(() => import('views/essay/EssayView')));
const IconManageMent = Loadable(lazy(() => import('views/icon-managemant/IconList')));
const Message = Loadable(lazy(() => import('views/messages/MessageList')));
const WorkGroupsManagement = Loadable(lazy(() => import('views/work-groups/WorkGroupsManagement')));
const AddWorkGroupsManagement = Loadable(lazy(() => import('views/work-groups/AddWorkGroupsManagement')));
const WorkGroupRecordManagement = Loadable(lazy(() => import('views/work-groups/WorkGroupRecordManagement')));
const WorkGroupsChannelsMessagesManagement = Loadable(lazy(() => import('views/work-groups/WorkGroupsChannelsMessagesManagement')));
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/',
            element: <Home />
        },
        {
            path: '/single-question',
            element: <SingleQuestion />
        },
        {
            path: '/single-question/add',
            element: <AddQestion />
        },
        {
            path: '/single-question/:id',
            element: <AddQestion />
        },
        {
            path: '/collection',
            element: <CollectionList />
        },
        {
            path: '/collection/add',
            element: <Collection />
        },
        {
            path: '/collection/:id',
            element: <Collection />
        },
        {
            path: '/user-list',
            element: <Users />
        },
        {
            path: '/user-groups',
            element: <UserGroups />
        },
        {
            path: '/user-groups/add',
            element: <UserGroupOptions isEdit={false} />
        },
        {
            path: '/user-groups/:id',
            element: <UserGroupOptions isEdit />
        },
        {
            path: '/logbook',
            element: <LogbookList />
        },
        {
            path: 'logbook/:id',
            element: <LogBookDetails />
        },
        {
            path: '/system-reports',
            element: <SystemReports />
        },
        {
            path: '/tag-management',
            element: <TagList />
        },
        {
            path: '/icon-management',
            element: <IconManageMent />
        },
        {
            path: '/products',
            element: <ProductList />
        },
        {
            path: '/product-categories',
            element: <ProductCategories />
        },
        {
            path: '/connection',
            element: <Connection />
        },
        {
            path: '/connectiontoproduct',
            element: <ConnectionToProduct />
        },
        {
            path: '/notemanagement',
            element: <NoteManageMent />
        },
        {
            path: '/essay',
            element: <Essay />
        },
        {
            path: '/products/add',
            element: <AddProduct />
        },
        {
            path: '/products/:id',
            element: <AddProduct />
        },
        {
            path: '/containers',
            element: <ContainerList />
        },
        {
            path: '/containers/add',
            element: <AddContainer />
        },
        {
            path: '/containers/:id',
            element: <AddContainer />
        },
        {
            path: '/assignments',
            element: <Assignments />
        },
        {
            path: '/assignments/add',
            element: <AddAssignment />
        },
        {
            path: '/rules/:id',
            element: <RulesPage />
        },
        {
            path: '/assignments/:id',
            element: <AddAssignment />
        },
        {
            path: '/courses',
            element: <CoursesList />
        },
        {
            path: '/courses/add',
            element: <AddCourse />
        },
        {
            path: '/courses/:id',
            element: <AddCourse />
        },
        {
            path: '/atomic-units',
            element: <AtomicUnitList />
        },
        {
            path: '/atomic-units/add',
            element: <AddAtomicUnit />
        },
        {
            path: '/atomic-units/:id',
            element: <AddAtomicUnit />
        },
        {
            path: '/specs',
            element: <SpecsList />
        },
        {
            path: '/specs/add',
            element: <AddSpecs />
        },
        {
            path: '/specs/:id',
            element: <AddSpecs />
        },
        {
            path: '/classes',
            element: <ClassesList />
        },
        {
            path: '/classes/:id',
            element: <ClassView />
        },
        {
            path: '/messages',
            element: <Message />
        },
        {
            path: '/essayview/:id/:student_id',
            element: <EssayView />
        },
        {
            path: '/work-groups-management',
            element: <WorkGroupsManagement />
        },
        {
            path: '/work-groups-management/add',
            element: <AddWorkGroupsManagement />
        },
        {
            path: '/work-groups-management/:id',
            element: <AddWorkGroupsManagement />
        },
        {
            path: '/work-group-record-management',
            element: <WorkGroupRecordManagement />
        },
        {
            path: '/work-group-channels-and-messages',
            element: <WorkGroupsChannelsMessagesManagement />
        }
    ]
};

export default MainRoutes;
